import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../stores/store';
import { AppRoute, SearchParam } from '../../constants/route';
import { useStartParcelCreation } from '../../hooks/use-start-parcel-creation.hook';

const GuestParcel = () => {
  const {
    commonStore: {
      setIsGuestParcelCreation,
      appLoaded,
      analyticsManager,
      isAnalyticsInitialized,
    },
    userStore: { user, isLoadingUser },
  } = useStore();

  const handleStartParcelCreation = useStartParcelCreation();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!appLoaded || isLoadingUser || !isAnalyticsInitialized) return;

    if (!user) {
      setIsGuestParcelCreation(true);
      analyticsManager.track('login_guest');
    }

    const redirectUrl = searchParams.get(SearchParam.REDIRECT);

    const isRedirectToParcelCreation =
      !!redirectUrl && redirectUrl.includes(AppRoute.PARCEL_CREATE);

    handleStartParcelCreation(
      isRedirectToParcelCreation ? redirectUrl : undefined
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    user,
    isLoadingUser,
    appLoaded,
    analyticsManager,
    isAnalyticsInitialized,
  ]);

  return null;
};

export default observer(GuestParcel);
